interface Props {

    text: string
    setText(text: string): void

    active: boolean

    disabled?: boolean
    placeholder?: string

    setHasFocus(hasFocus: boolean): void

}

export function TextArea(props: Props) {

    const { text, setText, active, disabled, placeholder, setHasFocus } = props

    const focusedMinHeight = 50

    const ref = React.useRef<HTMLTextAreaElement>()

    const [initFocus, setInitFocus] = React.useState(false)

    React.useEffect(() => {

        if (ref.current && (!initFocus) && active) {
            ref.current.focus()
            setInitFocus(true)
        }

    }, [ref?.current, initFocus, active])

    function updateHeight() {

        const element = ref.current

        if (element) {
            element.style.height = "0"
            const height = active
                ? Math.max(element.scrollHeight, focusedMinHeight)
                : element.scrollHeight
            element.style.height = height + 'px'
        }

    }

    React.useEffect(updateHeight, [ref.current, ref.current?.scrollHeight, active])

    return <textarea
        ref={ref}
        maxLength={200}
        style={{ resize: "none", overflow: "hidden" }}
        onFocus={() => setHasFocus(true)}
        onBlur={() => setHasFocus(false)}
        className="form-control"
        value={text || ""} disabled={disabled} onChange={e => setText(e.target.value)} placeholder={placeholder} />

}
